export default "__VITE_ASSET__Bgi5x_2N__"